var path = '/404.html';
var html = "<!doctype html> <html> <head> <meta http-equiv=Content-Type content=\"text/html; charset=UTF-8\"> <title>404 Error</title> </head> <body> <div> <p>We're sorry. You cannot access this site at this time. We apologize for the inconvenience.</p> <p>Nous sommes désolés. Vous ne pouvez pas accéder à ce site à ce moment. Nous nous excusons pour le désagrément.</p> </div> </body> </html> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/404.html
// module id = 761
// module chunks = 0 2